import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button/Button.js';
import { updateFavicon } from '../../utils/faviconUtils';
import './NotFound.css';

export const NotFound = () => {
  useEffect(() => {
    document.body.classList.add('not-found-page');
    document.documentElement.classList.add('not-found-page');
    return () => {
      document.body.classList.remove('not-found-page');
      document.documentElement.classList.remove('not-found-page');
    };
  }, []);

  // 404 page favicon: #404 background, #BF88BF icon
  useEffect(() => {
    updateFavicon('#404', '#BF88BF').catch(console.error);
    document.title = 'betterLCH — page not found';
  }, []);

  return (
    <div className="not-found">
      <h1>#404</h1>
      <p>Page not found, but the color is</p>
      <Link to="/">
          Explore more colors
      </Link>
    </div>
  );
};

